
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example-component', require('./components/ExampleComponent.vue'));
Vue.component('spo', require('./components/Spo.vue'));
Vue.component('travel-spo', require('./components/TravelSpo.vue'));
Vue.component('anket', require('./components/Anket.vue'));
Vue.component('map-country', require('./components/MapCountry.vue'));

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


const app1 = new Vue({
    el: '#app1'
});

const app = new Vue({
    el: '#app'
});



// WEBPACK FOOTER //
// ./resources/assets/js/vue.js